import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
import { Grid, TextField, FormControlLabel, Checkbox, Button } from '@mui/material';

function AddEmpresa({ handleNewEmpresa, editEmpresa }) {
  const { tienePermiso } = useAccesos();
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;
  // Campos principales en camelCase
  const [nombreCompleto, setNombreCompleto] = useState('');
  const [eslogan, setEslogan] = useState('');
  const [correoElectronico, setCorreoElectronico] = useState('');
  const [clave, setClave] = useState('');
  const [servidorCorreo, setServidorCorreo] = useState('');
  const [paginaWeb, setPaginaWeb] = useState('');
  const [imagenFondo, setImagenFondo] = useState('');
  const [rtn, setRtn] = useState('');
  const [doctorFirmante, setDoctorFirmante] = useState('');
  const [imagenFirma, setImagenFirma] = useState('');
  const [imagenSello, setImagenSello] = useState('');
  const [imagenReportes, setImagenReportes] = useState('');
  const [nombreRepresentante, setNombreRepresentante] = useState('');
  const [telefonoRepresentante, setTelefonoRepresentante] = useState('');
  const [correoRepresentante, setCorreoRepresentante] = useState('');
  const [cargoRepresentante, setCargoRepresentante] = useState('');
  const [servidorCorreoPuerto, setServidorCorreoPuerto] = useState('');
  const [requiereAutenticacion, setRequiereAutenticacion] = useState(false);
  const [requiereSsl, setRequiereSsl] = useState(false);
  const [nombreEmpresaAbreviado, setNombreEmpresaAbreviado] = useState('');
  const [tituloDoctor, setTituloDoctor] = useState('');
  const [porcentajeDescuentoTerceraEdad, setPorcentajeDescuentoTerceraEdad] = useState('');
  const [telefonosDeLaEmpresa, setTelefonosDeLaEmpresa] = useState('');
  const [puntosActivos, setPuntosActivos] = useState(false);
  const [porcentajeDescuentoCuartaEdad, setPorcentajeDescuentoCuartaEdad] = useState('');
  const [cantidadCertificaciones, setCantidadCertificaciones] = useState('');

  const { user } = useUser();
  const [isEditing, setIsEditing] = useState(false);
  const [IngresadoPor, setIngresadoPor] = useState('');

  useEffect(() => {
    // Si estamos editando, precargar datos en camelCase
    if (editEmpresa) {
      setNombreCompleto(editEmpresa.nombreCompleto || '');
      setEslogan(editEmpresa.eslogan || '');
      setCorreoElectronico(editEmpresa.correoElectronico || '');
      setClave(editEmpresa.clave || '');
      setServidorCorreo(editEmpresa.servidorCorreo || '');
      setPaginaWeb(editEmpresa.paginaWeb || '');
      setImagenFondo(editEmpresa.imagenFondo || '');
      setRtn(editEmpresa.rtn || '');
      setDoctorFirmante(editEmpresa.doctorFirmante || '');
      setImagenFirma(editEmpresa.imagenFirma || '');
      setImagenSello(editEmpresa.imagenSello || '');
      setImagenReportes(editEmpresa.imagenReportes || '');
      setNombreRepresentante(editEmpresa.nombreRepresentante || '');
      setTelefonoRepresentante(editEmpresa.telefonoRepresentante || '');
      setCorreoRepresentante(editEmpresa.correoRepresentante || '');
      setCargoRepresentante(editEmpresa.cargoRepresentante || '');
      setServidorCorreoPuerto(editEmpresa.servidorCorreoPuerto || '');
      setRequiereAutenticacion(editEmpresa.requiereAutenticacion || false);
      setRequiereSsl(editEmpresa.requiereSsl || false);
      setNombreEmpresaAbreviado(editEmpresa.nombreEmpresaAbreviado || '');
      setTituloDoctor(editEmpresa.tituloDoctor || '');
      setPorcentajeDescuentoTerceraEdad(editEmpresa.porcentajeDescuentoTerceraEdad?.toString() || '');
      setTelefonosDeLaEmpresa(editEmpresa.telefonosDeLaEmpresa || '');
      setPuntosActivos(editEmpresa.puntosActivos || false);
      setPorcentajeDescuentoCuartaEdad(editEmpresa.porcentajeDescuentoCuartaEdad?.toString() || '');
      setCantidadCertificaciones(editEmpresa.cantidad_certificaciones?.toString() || '');
      setIsEditing(true);
      setIngresadoPor(editEmpresa.ingresadoPor);
      0
          }
  }, [editEmpresa]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Construir objeto a enviar (en camelCase) con valores equivalentes
    const empresaData = {
      idEmpresa: editEmpresa ? editEmpresa.idEmpresa : 0,
      nombreCompleto,
      eslogan,
      correoElectronico,
      clave,
      servidorCorreo,
      paginaWeb,
      imagenFondo,
      rtn,
      doctorFirmante,
      imagenFirma,
      imagenSello,
      imagenReportes,
      nombreRepresentante,
      telefonoRepresentante,
      correoRepresentante,
      cargoRepresentante,
      servidorCorreoPuerto,
      requiereAutenticacion,
      requiereSsl,
      nombreEmpresaAbreviado,
      tituloDoctor,
      porcentajeDescuentoTerceraEdad: parseFloat(porcentajeDescuentoTerceraEdad) || 0,
      telefonosDeLaEmpresa,
      puntosActivos,
      porcentajeDescuentoCuartaEdad: parseFloat(porcentajeDescuentoCuartaEdad) || 0,
      cantidad_certificaciones: parseInt(cantidadCertificaciones, 10) || 0,

      // Metadatos de auditoría
      IngresadoPor: !editEmpresa ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
      ModificadoPor: editEmpresa ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
      fechaIngreso: new Date().toISOString(),
    };
console.log(empresaData);
    // Elegir método
    const method = isEditing ? 'PUT' : 'POST';
    const endpoint = isEditing
      ? `${server}/MgEmpresas/${editEmpresa.idEmpresa}`
      : `${server}/MgEmpresas`;

    try {
      const response = await fetch(endpoint, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(empresaData),
      });

      if (response.ok) {
        alert('Empresa guardada exitosamente!');
        handleNewEmpresa(); // refrescar lista y limpiar
        setIsEditing(false);
      } else {
        alert('Error al guardar la empresa');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error al guardar la empresa');
    }
  };

  const handleCancelarEdicion = () => {
    // Limpiar formulario
    setNombreCompleto('');
    setEslogan('');
    setCorreoElectronico('');
    setClave('');
    setServidorCorreo('');
    setPaginaWeb('');
    setImagenFondo('');
    setRtn('');
    setDoctorFirmante('');
    setImagenFirma('');
    setImagenSello('');
    setImagenReportes('');
    setNombreRepresentante('');
    setTelefonoRepresentante('');
    setCorreoRepresentante('');
    setCargoRepresentante('');
    setServidorCorreoPuerto('');
    setRequiereAutenticacion(false);
    setRequiereSsl(false);
    setNombreEmpresaAbreviado('');
    setTituloDoctor('');
    setPorcentajeDescuentoTerceraEdad('');
    setTelefonosDeLaEmpresa('');
    setPuntosActivos(false);
    setPorcentajeDescuentoCuartaEdad('');
    setCantidadCertificaciones('');
    setIsEditing(false);
  };

  return (
    // <div className="x_content">
      <form onSubmit={handleSubmit}>
        {/* Ajusta width y padding según tus necesidades */}
        <Grid container spacing={2} >
          {/* Columna 1 */}
          <Grid item xs={12} md={4}>
            <TextField
              label="Nombre Completo"
              variant="outlined"
              fullWidth
              required
              value={nombreCompleto}
              onChange={(e) => setNombreCompleto(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Eslogan"
              variant="outlined"
              fullWidth
              value={eslogan}
              onChange={(e) => setEslogan(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Correo Electrónico"
              variant="outlined"
              fullWidth
              type="email"
              value={correoElectronico}
              onChange={(e) => setCorreoElectronico(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Clave"
              variant="outlined"
              fullWidth
              type="password"
              value={clave}
              onChange={(e) => setClave(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Servidor Correo"
              variant="outlined"
              fullWidth
              value={servidorCorreo}
              onChange={(e) => setServidorCorreo(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Página Web"
              variant="outlined"
              fullWidth
              value={paginaWeb}
              onChange={(e) => setPaginaWeb(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Imagen Fondo"
              variant="outlined"
              fullWidth
              value={imagenFondo}
              onChange={(e) => setImagenFondo(e.target.value)}
              style={{ marginBottom: 10 }}
            />
          </Grid>

          {/* Columna 2 */}
          <Grid item xs={12} md={4}>
            <TextField
              label="RTN"
              variant="outlined"
              fullWidth
              value={rtn}
              onChange={(e) => setRtn(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Doctor Firmante"
              variant="outlined"
              fullWidth
              value={doctorFirmante}
              onChange={(e) => setDoctorFirmante(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Imagen Firma"
              variant="outlined"
              fullWidth
              value={imagenFirma}
              onChange={(e) => setImagenFirma(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Imagen Sello"
              variant="outlined"
              fullWidth
              value={imagenSello}
              onChange={(e) => setImagenSello(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Imagen Reportes"
              variant="outlined"
              fullWidth
              value={imagenReportes}
              onChange={(e) => setImagenReportes(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Nombre Representante"
              variant="outlined"
              fullWidth
              value={nombreRepresentante}
              onChange={(e) => setNombreRepresentante(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Teléfono Representante"
              variant="outlined"
              fullWidth
              value={telefonoRepresentante}
              onChange={(e) => setTelefonoRepresentante(e.target.value)}
              style={{ marginBottom: 10 }}
            />
          </Grid>

          {/* Columna 3 */}
          <Grid item xs={12} md={4}>
            <TextField
              label="Correo Representante"
              variant="outlined"
              fullWidth
              value={correoRepresentante}
              onChange={(e) => setCorreoRepresentante(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Cargo Representante"
              variant="outlined"
              fullWidth
              value={cargoRepresentante}
              onChange={(e) => setCargoRepresentante(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Puerto Correo"
              variant="outlined"
              fullWidth
              value={servidorCorreoPuerto}
              onChange={(e) => setServidorCorreoPuerto(e.target.value)}
              style={{ marginBottom: 10 }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={requiereAutenticacion}
                  onChange={(e) => setRequiereAutenticacion(e.target.checked)}
                />
              }
              label="Requiere Autenticación"
              style={{ marginBottom: 10 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={requiereSsl}
                  onChange={(e) => setRequiereSsl(e.target.checked)}
                />
              }
              label="Requiere SSL"
              style={{ marginBottom: 10 }}
            />

            <TextField
              label="Nombre Empresa Abreviado"
              variant="outlined"
              fullWidth
              value={nombreEmpresaAbreviado}
              onChange={(e) => setNombreEmpresaAbreviado(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Título Doctor"
              variant="outlined"
              fullWidth
              value={tituloDoctor}
              onChange={(e) => setTituloDoctor(e.target.value)}
              style={{ marginBottom: 10 }}
            />
          </Grid>

          {/* Fila extra para más campos */}
          <Grid item xs={12} md={4}>
            <TextField
              label="% Descuento Tercera Edad"
              variant="outlined"
              fullWidth
              value={porcentajeDescuentoTerceraEdad}
              onChange={(e) => setPorcentajeDescuentoTerceraEdad(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Teléfonos de la Empresa"
              variant="outlined"
              fullWidth
              value={telefonosDeLaEmpresa}
              onChange={(e) => setTelefonosDeLaEmpresa(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={puntosActivos}
                  onChange={(e) => setPuntosActivos(e.target.checked)}
                />
              }
              label="Puntos Activos"
              style={{ marginBottom: 10 }}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label="% Descuento Cuarta Edad"
              variant="outlined"
              fullWidth
              value={porcentajeDescuentoCuartaEdad}
              onChange={(e) => setPorcentajeDescuentoCuartaEdad(e.target.value)}
              style={{ marginBottom: 10 }}
            />
            <TextField
              label="Cantidad Certificaciones"
              variant="outlined"
              fullWidth
              value={cantidadCertificaciones}
              onChange={(e) => setCantidadCertificaciones(e.target.value)}
              style={{ marginBottom: 10 }}
            />
          </Grid>

          {/* Botones */}
          <Grid item xs={12}>
            <div style={{ textAlign: 'right', marginTop: '10px' }}>
              <Button
                variant="contained"
                onClick={handleCancelarEdicion}
                style={{ marginRight: 10 }}
              >
                Cancelar
              </Button>
              <Button variant="contained" color="primary" type="submit" disabled={!tienePermiso('Crear Empresa')}>
                Guardar
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>
    
  );
}

export default AddEmpresa;
